function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.6406 11.25C15.0723 11.25 15.4375 11.6152 15.4375 12.0469V14.4375C15.4375 16.1973 14.0098 17.625 12.25 17.625H3.75C1.95703 17.625 0.5625 16.1973 0.5625 14.4375V12.0469C0.5625 11.6152 0.894531 11.25 1.35938 11.25C1.79102 11.25 2.15625 11.6152 2.15625 12.0469V14.4375C2.15625 15.334 2.85352 16.0312 3.75 16.0312H12.25C13.1133 16.0312 13.8438 15.334 13.8438 14.4375V12.0469C13.8438 11.6152 14.1758 11.25 14.6406 11.25ZM8 0.625C8.23242 0.625 8.43164 0.724609 8.59766 0.923828L13.0137 5.9707C13.2129 6.16992 13.2793 6.43555 13.2793 6.70117C13.2793 6.86719 13.2793 7.0332 13.2129 7.16602C13.0137 7.56445 12.6484 7.79688 12.2168 7.79688H10.3574V11.7812C10.3574 12.5449 9.79297 13.1094 9.0293 13.1094H6.9043C6.17383 13.1094 5.57617 12.5449 5.57617 11.7812V7.79688H3.75C3.31836 7.79688 2.95312 7.56445 2.75391 7.16602C2.58789 6.76758 2.6543 6.30273 2.95312 5.9707L7.40234 0.923828C7.56836 0.724609 7.76758 0.625 8 0.625ZM8 2.65039L4.8457 6.20312H7.16992V11.5156H8.76367V6.20312H11.1211L8 2.65039Z",
  fill: "#767B87"
});

const SvgExportMenu = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgExportMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/export_menu.ef9ea86e.svg";
export { ForwardRef as ReactComponent };